export default __webpack_public_path__ + "static/media/room-mel-3.c2521e51.jpg";